import { App } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'
import {
  Directory,
  Encoding,
  Filesystem,
  WriteFileOptions,
  WriteFileResult,
} from '@capacitor/filesystem'
import { Media, MediaSaveOptions } from '@capacitor-community/media'

import { getPlatform } from '../app'

export const requestPermissions = async (): Promise<boolean> => {
  if (Capacitor.getPlatform() === 'web') {
    return true
  }
  const permission = await Filesystem.checkPermissions()
  if (permission.publicStorage === 'granted') return true
  if (permission.publicStorage === 'denied') throw Error('storageDeniedError')

  const { publicStorage } = await Filesystem.requestPermissions()

  return publicStorage === 'granted'
}

/**
 * @description save file (only support for mobile)
 * @param {WriteFileOptions} options
 */
export const writeFile = async (
  options: WriteFileOptions
): Promise<WriteFileResult | null> => {
  if (!(await requestPermissions())) {
    return null
  }
  return Filesystem.writeFile({
    directory: Directory.Documents,
    encoding: Encoding.UTF8,
    ...options,
  })
}

/**
 * @description 画像をデバイスに保存する
 * @param option MediaSaveOptions
 */
export const downloadImageUrl = async (options: MediaSaveOptions) => {
  if (!(await requestPermissions())) {
    return null
  }

  return Media.savePhoto(options)
}

/**
 * メディアが保存されるアルバムがなければ作成する
 * Androidの場合、Albumのidentifierが必須となる
 * @param name アルバム名
 */
export const createAlbum = async (name?: string) => {
  if (getPlatform() !== 'android') {
    return undefined
  }

  // Androidの場合、album指定が必須
  const albumName = name ?? (await App.getInfo()).name
  const albums = await Media.getAlbums()
  const album = albums.albums.find(a => a.name === albumName)
  if (album) {
    // すでに作成済みの場合
    return album.identifier
  }

  // なければアルバム作成
  await Media.createAlbum({ name: albumName })
  const newAlbums = await Media.getAlbums()
  return newAlbums.albums.find(a => a.name === albumName)?.identifier
}
